// 判断终端设备类型
const decideDeviceTool = require('@/lib/common');
const commonMethods = decideDeviceTool.default;

import Vue from 'vue'
import App from './App'
import router from './router'

import store from './store/index'
import cache from './store/cache'
import axios from './axios/common'
import qs from 'qs'


/*ElementUI*/
import ElementUI from 'element-ui'
import './assets/css/font-ie.css'
import 'element-ui/lib/theme-chalk/index.css'

/*NutUI*/
import {Popup, SideNavBar, SideNavBarItem, SubSideNavBar} from '@nutui/nutui';
import '@nutui/nutui/dist/nutui.css';
Popup.install(Vue);
SideNavBar.install(Vue);
SideNavBarItem.install(Vue);
SubSideNavBar.install(Vue);

Vue.config.productionTip = false


if (commonMethods._isMobile() && !commonMethods._isPc()) {
    // 加载移动端css
    import('./assets/mobile/css/common.css');
} else {
    // 加载PC端css
    import('./assets/css/common.css')
}


import logo_wh from './assets/resource/logos/logo.png'
import logo_bk from './assets/resource/logos/logo_bk.png'


Vue.prototype.$axios = axios;
Vue.prototype.$cache = cache;
Vue.prototype.$qs = qs;
Vue.prototype.$logo_wh = logo_wh;
Vue.prototype.$logo_bk = logo_bk;
Vue.prototype.$path = 'zh-cn';
Vue.prototype.$name = 'index';
Vue.prototype.$footActiveSide = [];
Vue.prototype.$RegistedName = {
    "0": {componentId: 0, componentName: "index"},
    "1": {componentId: 1, componentName: "about"},
    "2": {componentId: 2, componentName: "solution"},
    "3": {componentId: 3, componentName: "news"},
    "4": {componentId: 4, componentName: "support"},
    "5": {componentId: 5, componentName: "join"},
    "6": {componentId: 6, componentName: "software"},
    "7": {componentId: 7, componentName: "xhorseIM"},
    "8": {componentId: 8, componentName: "download"},
};
Vue.prototype.$visibleHomeTop = -4.5;

Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js